module.exports = __webpack_public_path__ + "img/Lightning-mobile.ebb89217.png";